import { React, useEffect, useState, useContext } from "react";
import { MyContextProvider } from "../../../../../App";
import axios from "axios";
import { API_URL, getAuthHeaders, getUserClaimsForUi } from "../../../../../Constant";
import { GlobalLoading, showLoading } from "react-global-loading";
import { handleUserLevelAccessPermissions,validateRolesIIPManufacturing} from "../../../../../Custom/Custom";
import { useNavigate } from "react-router-dom";
import iipTitleData from '../../../../../iip.json';
import { downloadFrQrIndexExcel } from "../../frQrIndexExcel";



function FRQRReportArchive() {

  const token = useContext(MyContextProvider).token;
  const decode_token = getUserClaimsForUi();
  const navigate = useNavigate();
  const storedLanguage = localStorage.getItem('language');
  const [fRQRReportArchive, setFRQRReportArchive]=useState([]);
  const [buttonAccess, setButtonAccess] = useState({
    userLevel: "",
    roles: "",
    isVisible: false,
});
const config = getAuthHeaders();



  useEffect(() => {
    const level = handleUserLevelAccessPermissions(decode_token);
    setButtonAccess(level);

    const userRole = async () => {
        showLoading(true);
        try {
            const role = await validateRolesIIPManufacturing(decode_token);
            if (!role) {
            alert("You are not an authorized for IIP Report");
            navigate("/dashboard");
            }else{
               handleGetFRQRReportData()
            }
            showLoading(false)
        } catch (error) {
            console.log(error);
            showLoading(false);
        }
        };
   userRole();


}, []);




//Handle Get All Data **********************
const handleGetFRQRReportData=()=>{
  showLoading(true);
  axios
      .get(`${API_URL}api/iipReports/ManufacturingSectorListReportGenerate`, config)
      .then((res) => {
      let response = res.data;
     if(response.status){
        let reportData=response.data.iipResultsDistrict;
         setFRQRReportArchive(reportData)
      }else{
        setFRQRReportArchive([])
      }
 
      })
      .catch((err) => {
      console.error(err);
      showLoading(false);
      }).finally(()=>{
        setTimeout(function(){showLoading(false)},200)
        ;
      })
}


// DownLoad file *************
const isIndexArchive = (item) =>
  item?.isIndexReport === true
  || String(item?.filename || '').startsWith('IndexReport_Monthly_')
  || String(item?.filePath || '').toLowerCase().includes('.json');

const downloadFile=async (item)=>{
  if (isIndexArchive(item)) {
    showLoading(true);
    try {
      const response = await axios.post(
        `${API_URL}api/iipReports/getFrQrArchiveIndexReport`,
        { id: item.id },
        config
      );
      if (!response.data?.status) {
        alert(response.data?.message || 'Unable to download index report');
        return;
      }
      const month = response.data?.data?.currentMonthData?.month;
      const year = response.data?.data?.currentMonthData?.year;
      const fileName = String(item.filename || `IndexReport_Monthly_${month}_${year}`).replace(/\.xlsx$/i, '');
      await downloadFrQrIndexExcel(
        response.data?.data?.MonthlyReportDataList,
        month,
        year,
        fileName
      );
    } catch (err) {
      console.error('Index archive download error:', err);
      alert(err?.response?.data?.message || err?.message || 'Unable to download index report');
    } finally {
      showLoading(false);
    }
    return;
  }

  let fileName=item.filename;
  let filePath=item.filePath;

  try {
    const response = await fetch(filePath, {
      method: 'GET',
      credentials: 'include',
      headers: { ...getAuthHeaders().headers },
    });

    if (response.ok) {
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } else {
      alert("File Not Found");
    }
  } catch (err) {
    console.error('Download error:', err);
    alert("File Not Found or Server Error");
  }
}



//Change Date Format (IST) **********
const formatDate = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  const istOffset = 5.5 * 60 * 60 * 1000;
  const istDate = new Date(date.getTime() + istOffset);
  const year = istDate.getUTCFullYear();
  const month = String(istDate.getUTCMonth() + 1).padStart(2, '0');
  const day = String(istDate.getUTCDate()).padStart(2, '0');
  const hours = String(istDate.getUTCHours()).padStart(2, '0');
  const minutes = String(istDate.getUTCMinutes()).padStart(2, '0');
  const seconds = String(istDate.getUTCSeconds()).padStart(2, '0');
  return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
}

  return (
    <>
      <GlobalLoading />
      <div className="container-fluid py-3">
      <div className="card mx-3 mb-3">
          <div className="card-body pb-1">
              <div className="row align-items-center">
                <h4 className="page_heading">
                   <div dangerouslySetInnerHTML={{ __html: storedLanguage === 'hi' ? iipTitleData.hi.FR_QR_REPORT_ARCHIVE : iipTitleData.en.FR_QR_REPORT_ARCHIVE }} />
                 </h4>
                
            </div>
          </div>
      </div>
      <div className="card mx-3 mb-3">
      <div className="card">
                    <div className="card-body">
                    <div className="table-responsive">
                          <table className="table table-bordered">
                              <thead>
                                  <tr>
                                    <th>Sr No</th>
                                      <th>File Name</th>
                                      <th>Month &amp; Year</th>
                                      <th>Download Time</th>
                                      <th className="text-center">File Download</th>
                                  </tr>
                              </thead>
                              <tbody>

                                {fRQRReportArchive.length>0 && 
                                fRQRReportArchive.map((item,index)=>{
                                    return <>
                                      <tr key={item.id}>
                                        <td>{index+1}</td>
                                        <td>{item.filename}</td>
                                        <td>{item.selectedMonthYear}</td>
                                        <td>{formatDate(item.downloadTime)}</td>
                                        <td className="text-center">
                                          <button 
                                          className="btn btn-sm btn_green"
                                          onClick={()=>(downloadFile(item)
                                          )} 
                                          >
                                            Download
                                            &nbsp;
                                          <i className="fa fa-download"></i>
                                        </button>
                                        </td>
                                      </tr>
                                    </>

                                })

                                }
                                  
                                
                                  
                              </tbody>
                          </table>
                      </div>
                        
                    
                    </div>
                </div>
        </div>


      </div>
   </>
  )
}

export default FRQRReportArchive
